var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"i-frame"},[_c('iframe',{attrs:{"src":_vm.documentPath,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }